export default __webpack_public_path__ + "static/media/discount-dashboard-icon-selected.4068b0ad.svg";